import { apiSlice } from "../apiSlice";

export const bannerApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        showBanner: builder.mutation({
            query: (data) => ({
                url: 'slider/show/' + data,
                method: 'GET',
                credentials: "include",
            }),
            providesTags: ['specification']

        }),

        createBanner: builder.mutation({
            query: (data) => ({
                method: "POST",
                body: data,
                url: 'slider',
                credentials: "include",
            })
        }),

        getBanner: builder.query({
            query: (data) => ({
                url: 'slider/list' + data,
                method: 'GET',
                credentials: "include",
            }),
            providesTags: ['specification']

        }),
        bannerDelete: builder.mutation({
            query: (id) => ({
                url: "slider/" + id,
                method: 'DELETE',
                body: id,
                credentials: "include",
            }),

        }),

    }),
});

export const {
    useCreateBannerMutation,
    useGetBannerQuery,
    useShowBannerMutation,
    useBannerDeleteMutation
} = bannerApi;